import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import classNames from 'classnames';
import FormattedCurrency, { formatCount } from '@/shared/components/FormattedCurrency';
import messages from './messages';
export const ageBucketMessage = (bucket) => {
    switch (bucket) {
        case 'notDue':
            return messages.AgeNotDue;
        case 'd1to30':
            return messages.Age1To30;
        case 'd31to60':
            return messages.Age31To60;
        case 'd61to90':
            return messages.Age61To90;
        default:
            return messages.Age90Plus;
    }
};
// Horizontal bar per age bucket, scaled to the largest bucket. Rows act as filters for the invoice table.
const AgeingBar = ({ totals, selected, onToggle }) => {
    const intl = useIntl();
    const largest = Math.max(...totals.map(x => x.amount), 0) || 1;
    return (_jsxs("div", Object.assign({ className: "ageing" }, { children: [_jsx("div", Object.assign({ className: "ageing-title" }, { children: _jsx(FormattedMessage, Object.assign({}, messages.OpenAmountByAge)) })), _jsx("div", Object.assign({ className: "ageing-rows" }, { children: totals.map(x => {
                    const isSelected = selected.includes(x.bucket);
                    return (_jsxs("div", Object.assign({ className: classNames('ageing-row', {
                            selected: isSelected,
                            dimmed: selected.length > 0 && !isSelected,
                            empty: x.amount <= 0,
                        }), onClick: () => onToggle(x.bucket), title: intl.formatMessage(messages.InvoiceCount, {
                            count: x.count,
                            formatted: formatCount(x.count),
                        }) }, { children: [_jsx("span", Object.assign({ className: "ageing-label" }, { children: _jsx(FormattedMessage, Object.assign({}, ageBucketMessage(x.bucket))) })), _jsx("span", Object.assign({ className: "ageing-track" }, { children: _jsx("span", { className: classNames('ageing-fill', `age-${x.bucket}`), style: {
                                        width: `${Math.max((x.amount / largest) * 100, x.amount > 0 ? 2 : 0)}%`,
                                    } }) })), _jsx("span", Object.assign({ className: "ageing-amount" }, { children: _jsx(FormattedCurrency, { value: x.amount }) })), _jsx("span", Object.assign({ className: "ageing-count" }, { children: formatCount(x.count) }))] }), x.bucket));
                }) }))] })));
};
export default AgeingBar;
